import { pick } from 'lodash';

export const name = 'Размова: Адказаць на пытанне ўголас';
export const nameShort = 'Адказаць на пытанне ўголас';
export const bgInTable = '#008B8B';

export const fields = [
  {
    name: 'correctAnswers',
    default: [],
    label: 'Правільныя адказы',
    component: 'ListNewValues',
  },
  {
    name: 'afterTaskExplanation',
    default: '',
    label: 'Тлумачэнне задання',
    component: 'Textarea',
  },
  {
    name: 'textContent',
    default: '',
    label: 'Змест задання',
    component: 'Input',
  },
];

export const dataToSend = form => {
  return {
    additionalData: {
      afterTaskExplanation: form.afterTaskExplanation,
      textContent: form.textContent,
    },
    type: 'answer_question_aloud',
    name: form.name,
    tip: form.tip || '',
    status: form.status,
    correctAnswers: form.correctAnswers,
  };
};

export const parseData = data => {
  const dataFast = pick(data, ['name', 'status', 'tip', 'correctAnswers']);
  const { afterTaskExplanation, textContent } = data.additionalData;
  return {
    ...dataFast,
    afterTaskExplanation,
    textContent,
  };
};
